var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_766_23218)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_766_23218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93747 16.1846C6.13217 14.8324 6.13217 13.1676 6.93747 11.8154L11.1798 4.69169C11.9873 3.33566 13.4819 2.5 15.0996 2.5L23.5674 2.5C25.1851 2.5 26.6797 3.33566 27.4872 4.69169L31.7295 11.8154C32.5348 13.1676 32.5348 14.8324 31.7295 16.1846L27.4872 23.3083C26.6797 24.6643 25.1851 25.5 23.5674 25.5L15.0996 25.5C13.4819 25.5 11.9873 24.6643 11.1798 23.3083L6.93747 16.1846Z",
    fill: "#1E1E1E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9897 7.03237C17.002 7.21884 16.1856 7.83612 15.7605 8.71803C15.592 9.06764 15.5146 9.33836 15.4703 9.73339C15.3544 10.766 15.8242 11.8273 16.6826 12.4723C16.9314 12.6592 17.3838 12.8791 17.7066 12.9701C18.1775 13.1027 18.8229 13.1079 19.3071 12.9831C19.6119 12.9045 20.1246 12.6587 20.3715 12.4727C21.2309 11.8252 21.6997 10.766 21.5839 9.73339C21.5396 9.33836 21.4622 9.06764 21.2936 8.71803C20.901 7.90359 20.1717 7.31136 19.2748 7.07862C18.9633 6.99779 18.2995 6.97391 17.9897 7.03237ZM15.3317 14.3508C14.7541 14.4735 14.2869 14.7271 13.8611 15.1491C13.4301 15.5763 13.1762 16.0395 13.0545 16.6208C13.0067 16.8493 13.0007 17.0197 13.0004 18.1644L13 19.4511L13.0655 19.5474C13.1014 19.6003 13.1746 19.6729 13.228 19.7085L13.3252 19.7734H16.7322C18.606 19.7734 20.1391 19.7683 20.1391 19.7621C20.1391 19.7559 20.094 19.6564 20.0389 19.541C19.8365 19.1175 19.8363 18.652 20.0382 18.2471C20.093 18.1372 20.1542 18.0249 20.1743 17.9974C20.2038 17.9571 20.2038 17.9379 20.1743 17.8976C20.1542 17.8701 20.093 17.7578 20.0382 17.6479C19.9038 17.3783 19.8576 17.0831 19.9038 16.7887C19.9467 16.5154 19.9871 16.4251 20.3488 15.7935C20.5802 15.3894 20.6828 15.2402 20.83 15.0937C21.1362 14.789 21.5014 14.6393 21.9409 14.6384C22.129 14.638 22.1475 14.6326 22.1769 14.5685C22.207 14.5032 22.2015 14.4963 22.088 14.4552C21.6716 14.3046 21.8588 14.3126 18.599 14.3054C15.7685 14.2992 15.5609 14.3021 15.3317 14.3508ZM23.3987 14.9519C23.2746 15.0269 23.2568 15.0753 23.2058 15.4796C23.1801 15.6826 23.1477 15.831 23.1261 15.8441C23.1061 15.8563 23.0185 15.9083 22.9315 15.9598C22.8444 16.0113 22.7469 16.07 22.7149 16.0903C22.664 16.1225 22.6116 16.1084 22.3015 15.9791C21.9131 15.8172 21.8134 15.809 21.7008 15.9294C21.6681 15.9645 21.5208 16.1986 21.3737 16.4497C21.1591 16.8157 21.1066 16.9275 21.1083 17.014C21.1111 17.1461 21.1443 17.1841 21.4884 17.4481L21.7581 17.655V17.9475V18.2399L21.4884 18.4469C21.1443 18.7109 21.1111 18.7488 21.1083 18.881C21.1066 18.9675 21.1591 19.0793 21.3737 19.4453C21.5208 19.6964 21.6681 19.9305 21.7008 19.9656C21.8134 20.086 21.9131 20.0777 22.3015 19.9158C22.6116 19.7865 22.664 19.7724 22.7149 19.8046C22.7469 19.825 22.8444 19.8837 22.9315 19.9351C23.0185 19.9866 23.1061 20.0387 23.1261 20.0509C23.1475 20.0638 23.1807 20.2121 23.2065 20.4094C23.2601 20.8192 23.2785 20.8705 23.3985 20.943C23.4843 20.9948 23.5438 21 24.0541 21C24.8328 21 24.8238 21.0063 24.9018 20.4094C24.9276 20.2121 24.9608 20.0638 24.9821 20.0509C25.0022 20.0387 25.0898 19.9866 25.1768 19.9351C25.2639 19.8837 25.3614 19.8249 25.3935 19.8046C25.4444 19.7724 25.4969 19.7864 25.8086 19.9154C26.1984 20.0768 26.2959 20.085 26.4075 19.9656C26.4402 19.9305 26.5874 19.6964 26.7346 19.4453C26.9491 19.0793 27.0017 18.9675 27 18.881C26.9972 18.7483 26.9626 18.7086 26.6199 18.4458L26.3502 18.239V17.9475V17.656L26.6199 17.4491C26.9626 17.1863 26.9972 17.1467 27 17.014C27.0017 16.9275 26.9491 16.8157 26.7346 16.4497C26.5874 16.1986 26.4402 15.9645 26.4075 15.9294C26.2959 15.81 26.1984 15.8182 25.8086 15.9795C25.4969 16.1086 25.4444 16.1226 25.3935 16.0904C25.3614 16.07 25.2639 16.0113 25.1768 15.9598C25.0898 15.9083 25.0022 15.8563 24.9821 15.8441C24.9606 15.831 24.9282 15.6826 24.9025 15.4796C24.8515 15.0753 24.8337 15.0269 24.7096 14.9519C24.6241 14.9002 24.5642 14.895 24.0541 14.895C23.544 14.895 23.4842 14.9002 23.3987 14.9519ZM24.5766 16.8563C24.8171 16.9736 25.037 17.1918 25.1557 17.4307C25.2443 17.6092 25.2488 17.6339 25.2488 17.9475C25.2488 18.261 25.2443 18.2857 25.1557 18.4643C25.0368 18.7037 24.8171 18.9213 24.5756 19.0392C24.3954 19.1271 24.3705 19.1315 24.0541 19.1315C23.7378 19.1315 23.7128 19.1271 23.5327 19.0392C23.2911 18.9213 23.0715 18.7037 22.9526 18.4643C22.864 18.2857 22.8595 18.261 22.8595 17.9475C22.8595 17.6344 22.864 17.609 22.952 17.432C23.1007 17.1326 23.3804 16.8883 23.6881 16.7891C23.7662 16.7639 23.9127 16.7526 24.099 16.7572C24.3588 16.7638 24.4078 16.7739 24.5766 16.8563Z",
    fill: "#E9BE5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_766_23218",
    x: 0.346884,
    y: 0.0349245,
    width: 38.6775,
    height: 35.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.23254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_766_23218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.352154,
    dy: 4.04977
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.16938
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_766_23218",
    result: "effect2_dropShadow_766_23218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_766_23218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_766_23218",
    x: 4.152,
    y: 0.318499,
    width: 30.363,
    height: 27.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.09075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_766_23218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_766_23218",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.335615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_766_23218"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_766_23218",
    result: "effect3_innerShadow_766_23218"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementDark);
export default __webpack_public_path__ + "static/media/management-dark.d1f021ce65db7da2d91778a5f6b85a36.svg";
export { ForwardRef as ReactComponent };